import { render, staticRenderFns } from "./QuickLink.vue?vue&type=template&id=3d8bc556&scoped=true"
import script from "./QuickLink.vue?vue&type=script&lang=js"
export * from "./QuickLink.vue?vue&type=script&lang=js"
import style0 from "./QuickLink.vue?vue&type=style&index=0&id=3d8bc556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8bc556",
  null
  
)

export default component.exports